import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34; // 00:17:34

function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function Countdown() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units = [{
    value: pad(hours),
    label: 'Hours'
  }, {
    value: pad(minutes),
    label: 'Min'
  }, {
    value: pad(seconds),
    label: 'Sec'
  }];
  return <div className="w-full rounded-2xl border border-teal-400/30 bg-navy-900/60 p-4" data-id="element-65" data-mp="10cl9sea8pw7t">
      <p className="flex items-center justify-center gap-2 text-[11px] font-bold uppercase tracking-[0.18em] text-teal-400 sm:text-xs" data-id="element-66" data-mp="15bg1y6u3kx4l">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-67" data-mp="y0es26zuwm44" />
        This price expires in
      </p>
      <div className="mt-3 flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" data-id="element-68" data-mp="t2v8qsoaxj5b">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-69" data-mp="12s54ciictjy6" data-mpi={i}>
            <div className="flex min-w-[64px] flex-col items-center rounded-xl bg-white/95 px-3 py-2 shadow-inner sm:min-w-[76px]" data-id="element-70" data-mp="12t7wetrexsfo">
              <span className="font-display text-3xl font-black tabular-nums text-navy sm:text-4xl" data-id="element-71" data-mp="f45edksv9xkn">
                {unit.value}
              </span>
              <span className="text-[10px] font-bold uppercase tracking-widest text-navy/50" data-id="element-72" data-mp="o41uuz53rq4m">
                {unit.label}
              </span>
            </div>
            {i < units.length - 1 && <span className="font-display text-2xl font-black text-teal-400" data-id="element-73" data-mp="1zh4a9qvgu9n7">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}